import { useState, useEffect, useContext } from "react"
import { FirebaseContext } from "../firebase"
import { LogError } from "../helpers/logger"

export function useFirebaseFileUrl(path) {
  const [url, setUrl] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const firebase = useContext(FirebaseContext)

  useEffect(() => {
    if (!path || typeof path !== "string") {
      setLoading(false)
      setUrl(null)
      return
    }

    let isMounted = true
    const { getStorage, ref, getDownloadURL } = firebase.storage
    const storage = getStorage()
    const fileRef = ref(storage, path)

    setLoading(true)
    setError(null)

    getDownloadURL(fileRef)
      .then((downloadURL) => {
        if (isMounted) {
          setUrl(downloadURL)
        }
      })
      .catch((err) => {
        LogError("[useFirebaseFileUrl] Error fetching download URL:", err)
        if (isMounted) {
          setError(err)
        }
      })
      .finally(() => {
        if (isMounted) {
          setLoading(false)
        }
      })

    return () => {
      isMounted = false
    }
  }, [path, firebase.storage])

  return { url, loading, error }
}